module.exports = __webpack_public_path__ + "assets/img/logo-white.5ba4e2ae.svg";